import $ from 'jquery';

function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

if ('addEventListener' in window) {
  window.addEventListener('load', function () {
    let trigger = document.querySelector('.trigger');
    let nav = document.querySelector('.nav--main');

    if (nav != null) {

      let triggerOffset = offset(trigger)

      const doc = document.documentElement
      let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

      if (top > triggerOffset.top) {
        nav.classList.add('nav--main--sticky')
      } else {
        nav.classList.remove('nav--main--sticky')
      }

      window.addEventListener('scroll', function (e) {

        // Trigger sticky class on scroll
        const doc = document.documentElement
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

        if (top > triggerOffset.top) {
          nav.classList.add('nav--main--sticky')
        } else {
          nav.classList.remove('nav--main--sticky')
        }

        // Go for Parallax
        let bannerImage = document.querySelector('.banner__image')
        if (bannerImage != null) {
          bannerImage.style = 'transform: translate3d(0, ' + (top / 2) + 'px, 0);'
        }

        let bannerContent = document.querySelector('.banner__content')
        if (bannerContent != null) {
          bannerContent.style = 'transform: translate3d(0, ' + (top / 3) + 'px, 0);'
        }

        let breakOutImages = document.querySelectorAll('.article__list__image--breakOut')
        breakOutImages = [].slice.call(breakOutImages);
        if (breakOutImages != null) {

          breakOutImages.forEach(function (breakOutImage) {
            if (breakOutImage.getBoundingClientRect().top < window.innerHeight) {
              let breakoutImagePosition = getPosition(breakOutImage)
              breakOutImage.style = 'transform: translate3d(0, -' + (breakoutImagePosition.y / 10) + 'px, 0);'
            } else {
              breakOutImage.style = 'transform: translate3d(0, 0, 0);'
            }
          })
        }
      })
    }

  })
}

// Helper function to get an element's exact position
function getPosition(el) {
  var xPos = 0
  var yPos = 0

  while (el) {
    if (el.tagName == 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft
      var yScroll = el.scrollTop || document.documentElement.scrollTop

      xPos += (el.offsetLeft - xScroll + el.clientLeft)
      yPos += (el.offsetTop - yScroll + el.clientTop)
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft)
      yPos += (el.offsetTop - el.scrollTop + el.clientTop)
    }

    el = el.offsetParent
  }
  // console.log(yPos, xPos)
  return {
    x: xPos,
    y: yPos
  }
}

// deal with the page getting resized or scrolled
window.addEventListener('scroll', updatePosition, false)
window.addEventListener('resize', updatePosition, false)

function updatePosition() {
  // add your code to update the position when your browser
  // is resized or scrolled
}

// Readmore Scripts
// TODO: make read more/less text multilingual
let readmoreSections = document.querySelectorAll('.readmore');
readmoreSections = [].slice.call(readmoreSections);
if (readmoreSections != null) {
  readmoreSections.forEach(function (readmoreSection) {
    let readmoreButton = readmoreSection.nextElementSibling
    if (readmoreButton != null) {
      // console.log(1)
      readmoreButton.addEventListener('click', function () {
        if (readmoreSection.classList.contains('readmore--expanded')) {
          readmoreSection.classList.remove('readmore--expanded')
          readmoreButton.setAttribute('data-text', readmoreButton.getAttribute('data-text-readmore'))
        } else {
          readmoreSection.classList.add('readmore--expanded')
          readmoreButton.setAttribute('data-text', readmoreButton.getAttribute('data-text-readless'))
        }
      }, false)
    }
  })
}
let dqFormClose;
// DQ Form Scripts
let dqForm = document.querySelector('.form--wrapper')
if (dqForm != null) {
  // close popup
  dqFormClose = function () {
    dqForm.classList.remove('form--wrapper--open')
  }
  // open popup
  let dqFormOpen = function () {
    dqForm.classList.add('form--wrapper--open')
  }

  // on click to close popup is in html see `button.popup__close[onclick]` in contactView

  // add on click to open popup
  let dqFormButtons = document.querySelectorAll('.popup__btn-open')
  dqFormButtons = [].slice.call(dqFormButtons);
  if (dqFormButtons != null) {
    dqFormButtons.forEach(function (dqFormButton) {
      dqFormButton.addEventListener('click', function (e) {
        e.preventDefault()
        dqFormOpen()
      })
    })
  } else console.error('could not add event listener to open popup button')
}

// Slider Scripts
var sliderFunction = function() {
  let sliders = document.querySelectorAll('.slider')
  sliders = [].slice.call(sliders);
  if (sliders != null) {
    sliders.forEach(function (slider) {
      let sliderToggles = slider.querySelectorAll('.slider__toggle')
      let sliderBtnR = slider.querySelector('.slider__nav__arrow--right')
      let sliderBtnL = slider.querySelector('.slider__nav__arrow--left')
      let sliderAutoPlayInterval

      if (sliderToggles != null) {
        var direction = 'right';
        var autoplay = false;
        function slide(direction, autoplay) {
          // stop auto play
          if (sliderAutoPlayInterval !== null && !autoplay) {
            clearInterval(sliderAutoPlayInterval)
            sliderAutoPlayInterval = null
          }

          let oldSlideNumber = parseInt(slider.getAttribute('data-slide') | '0')
          // declare next slide
          let newSlideNumber

          let slidesTotal = sliderToggles.length - 1

          // initialize next slide
          if (direction === 'right') {
            newSlideNumber = oldSlideNumber + 1
            if (newSlideNumber > slidesTotal) {
              newSlideNumber = 0
            }
          } else if (direction === 'left') {
            newSlideNumber = oldSlideNumber - 1
            if (newSlideNumber < 0) {
              newSlideNumber = slidesTotal
            }
          }

          // set slide attr
          slider.setAttribute('data-slide', '' + newSlideNumber)

          // change slide
          sliderToggles[newSlideNumber].checked = true
        }

        // set slide attr
        slider.setAttribute('data-slide', '0')

        sliderBtnR.addEventListener('click', function () {
          slide('right')
        })
        sliderBtnL.addEventListener('click', function () {
          slide('left')
        })

        // start auto play
        sliderAutoPlayInterval = setInterval(function () {
          slide('right', true)
        }, 3e3)
      }
    })
  }
};

if($('.slider__footer').length) {
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    return elementBottom > windowTop && elementTop < windowBottom;
  };

  var execute = false;
  $(window).on('resize scroll', function () {
    if (!execute) {
      if ($('.slider__footer').isInViewport()) {
        sliderFunction();
        execute = true;
      }
    }
  });
}

let headerMenu = document.querySelector('.nav--main')
if (headerMenu != null) {
  let hamburger = headerMenu.querySelector('.nav__hamburger')
  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('nav__hamburger--active')
    headerMenu.classList.toggle('nav--active')
  })
}

$('.people__person').on('touchstart touchend', function(e) {
  e.preventDefault();
  $(this).toggleClass('hover_effect');
});

// Navigation visible on scrollUp

let lastScrollTop = 0;
let scrollpos = window.scrollY;
// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function(){
  let st = window.pageYOffset || document.documentElement.scrollTop;
  scrollpos = window.scrollY;
  if(window.scrollY <= 1) {
    document.getElementById("navigation").style.position = "absolute";
  }else {
    document.getElementById("navigation").style.position = "";
  }
  if (st > lastScrollTop){
    // downscroll code
    if (document.getElementById("navigation").classList.contains('nav--fixed')) {
      // do some stuff
      headerMenu.classList.add("nav--fadeOut");
    } else {
      headerMenu.classList.remove("nav--fixed");
    }
    if(scrollpos > 100) {
      headerMenu.classList.add("nav--down");
    }
    headerMenu.classList.add("nav--fixed");
  } else {
    // upscroll code
    headerMenu.classList.remove("nav--fadeOut");

  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);
